export const parseHtmlDocument = (html: string): Document => {
  const parser = new DOMParser();
  return parser.parseFromString(html, 'text/html');
};

export const reexecuteScriptsWithin = (container: ParentNode): void => {
  const scripts = Array.from(container.querySelectorAll('script'));

  scripts.forEach((oldScript) => {
    const newScript = document.createElement('script');
    for (let i = 0; i < oldScript.attributes.length; i += 1) {
      const attr = oldScript.attributes[i];
      if (attr) {
        newScript.setAttribute(attr.name, attr.value);
      }
    }

    newScript.text = oldScript.textContent || '';
    oldScript.parentNode?.replaceChild(newScript, oldScript);
  });
};

export const replaceSectionFromDocument = (
  selector: string,
  sourceDoc: Document,
  options: { targetRoot?: ParentNode; runScripts?: boolean } = {}
): HTMLElement | null => {
  const targetRoot = options.targetRoot ?? document;
  const currentSection = targetRoot.querySelector<HTMLElement>(selector);
  if (!currentSection) {
    return null;
  }

  const nextSection = sourceDoc.querySelector<HTMLElement>(selector);
  if (!nextSection) {
    return null;
  }

  currentSection.replaceWith(nextSection);

  const refreshedSection = document.querySelector<HTMLElement>(selector);
  if (!refreshedSection) {
    return null;
  }

  if (options.runScripts) {
    reexecuteScriptsWithin(refreshedSection);
  }

  return refreshedSection;
};
